const MAX_DATE_SUPPORTED = 8640000000000000 / 1000;
// ? Why this value? => https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#:~:text=It%20should%20be%20noted%20that%20the%20maximum%20Date,equivalent

export enum DisplayUpTo {
  SECONDS = 'sec',
  MINUTES = 'mins',
  HOURS = 'hrs',
}

export const convertSecondsToDisplayTimer = (
  timeInSeconds: number,
  displayUpTo: DisplayUpTo = DisplayUpTo.HOURS
) => {
  if (
    typeof timeInSeconds === 'number' &&
    timeInSeconds >= 0 &&
    timeInSeconds < MAX_DATE_SUPPORTED
  ) {
    const measuredTime = new Date(0);
    measuredTime.setSeconds(timeInSeconds); // specify value of SECONDS
    let mhsTime = measuredTime.toISOString().substr(11, 8);

    switch (displayUpTo) {
      case DisplayUpTo.MINUTES:
        return mhsTime.slice(-5);
      case DisplayUpTo.SECONDS:
        return mhsTime.slice(-2);
      default:
        break;
    }

    return mhsTime;
  }

  return '';
};

export const getCurrentDate = () => {
  const dateObj = new Date();
  let date = dateObj.getDate();
  let month = dateObj.getMonth() + 1;
  let year = dateObj.getFullYear();
  return `${date}/${month}/${year}`;
};

export const transformDate = (date: Date) => {
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return new Intl.DateTimeFormat('en-US', options).format(date);
};
